var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"aeon-pay-app",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openAeonPay}},[_c('img',{attrs:{"src":"/assets/images/icon/aeon-pay-logo.png","alt":"","width":"68"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }